import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import {
  CountryAutocompleteModule
} from '@shared/component/form-controls/autocomplete/country-autocomplete/country-autocomplete.module';
import { KeyValuePipe } from '@angular/common';
import { MatError, MatFormField, MatInput, MatLabel } from '@angular/material/input';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { ReactiveFormsModule } from '@angular/forms';
import { ReactiveTypedFormsModule } from '@rxweb/reactive-form-validators';
import { ValidationErrorModule } from '@shared/component';
import { AddressForm, StatesEnum } from 'taxtank-core';

@Component({
  selector: 'app-address-manual',
  imports: [
    CountryAutocompleteModule,
    KeyValuePipe,
    MatError,
    MatFormField,
    MatInput,
    MatLabel,
    MatOption,
    MatSelect,
    ReactiveFormsModule,
    ReactiveTypedFormsModule,
    ValidationErrorModule
  ],
  templateUrl: './address-manual.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './address-manual.component.scss',
})
export class AddressManualComponent {
  @Input() form: AddressForm;

  states: typeof StatesEnum = StatesEnum;
}
